import { List, Record } from 'immutable';

export const SpecialtiesList = new Record({
	id: null,
	isNew: true,
	count: null,
	items: new List(),
	created_at: new Date(),

})

export function createSpecialtiesList(data) {
	return new SpecialtiesList({
		id: data.id,
		isNew:false,
		items : new List(data.items) || new List(),
		count: data.count,
	});
}
